<template>
    <div v-if="drugs && conditions && symptoms" class="symptoms-test-data">
        <div class="info basic-info">
            <div>
                <span class="info-data age">Godine<span>{{age}}</span> </span>
                <span class="info-data gender">Pol<span>{{gender === 'male' ? 'Muški' : 'Ženski'}}</span> </span>
            </div>
            <div class="edit" @click="onEditData(1)">izmeni</div>
        </div>

        <div v-if="symptoms.length > 0" class="info">
            <span class="info-data">Simptomi</span>
            <div v-if="activeStep !== 2" @click="onEditData(2)" class="edit">izmeni</div>
        </div>
        <ul v-if="symptoms.length > 0" class="symptoms-list">
            <li 
                v-for="symptom in symptoms" 
                :key="symptom.id" 
                class="symptoms-item" >
                {{symptom.name}}
                <span v-if="activeStep === 2" @click="onRemoveSymptom(symptom)">x</span> 
            </li>
        </ul>

        <div v-if="drugs.length > 0" class="info">
            <span class="info-data">Lekovi koje koristite</span>
        </div>
        <ul v-if="drugs.length > 0" class="symptoms-list">
            <li 
                v-for="drug in drugs" 
                :key="drug.id" 
                class="symptoms-item" >
                {{drug.name}}
                <span v-if="activeStep === 3" @click="onRemoveDrug(drug)">x</span> 
            </li>
        </ul>

        <div v-if="conditions.length > 0" class="info">
            <span class="info-data">Istorijat bolesti</span>
        </div>
        <ul v-if="conditions.length > 0" class="symptoms-list">
            <li 
                v-for="condition in conditions" 
                :key="condition.id" 
                class="symptoms-item" >
                {{condition.name}}
                <span v-if="activeStep === 3" @click="onRemoveCondition(condition)">x</span> 
            </li>
        </ul>
    </div>
</template>

<script>

export default {
  name: 'test-data-box',
  components: {
  },

  props: ['activeStep', 'age', 'gender', 'symptoms', 'conditions', 'drugs'],

  data(){
    return {
      
    }
  },

  methods: {
      onRemoveSymptom(symptom) {
          this.$emit('symptomRemoved', { ...symptom });
      },
      onEditData(step) {
          this.$emit('editData', step);
      },
      onRemoveDrug(drug) {
          this.$emit('drugRemoved', drug);
      },
      onRemoveCondition(condition) {
          this.$emit('conditionRemoved', condition);
      }
  }
  
}
</script>

<style>
    .edit {
        cursor: pointer;
    }
    .symptoms-test-data .edit:hover {
        color: black!important;
    }
</style>
